import React, { useContext, useEffect } from "react"
import styled from "styled-components"
import FilterContext from "../../../context/filterContext"
import { ArrowRight } from "@styled-icons/bootstrap"
import { Link } from "react-router-dom"
import { kebabCase } from "../../../utils/kebabCase"

const Container = styled.div`
	max-width: 1120px;
	margin: auto;
	margin-top: 29px;
	border-top: 1px solid #f7f7f7;
	padding-top: 25px !important;
`

const SectionTitle = styled.span`
	display: block;
	margin-bottom: 32px;
	color: #050505;
	font-family: Mallory-Book;
	font-size: 24px;
	font-weight: 300;
	letter-spacing: 0;
	line-height: 22px;
	text-align: center;
`

const CategoryContainer = styled.div`
	display: grid;
	gap: 26px;
	grid-template-columns: repeat(4, 260px);
	margin-bottom: 25px;

	@media (max-width: 767px) {
		justify-content: center;
		gap: 12px;
		grid-template-columns: repeat(2, 169px);
		margin-bottom: 25px;
	}
`

const CategoryTile = styled.div`
	position: relative;
	cursor: pointer;
	background-color: purple;
	height: 333px;
	width: 260px;

	@media (max-width: 767px) {
		width: 169px;
		height: 240px;
	}
`

const CategoryTileImage = styled.img`
	z-index: 3;
	position: absolute;
	height: 333px;
	object-fit: cover;

	@media (max-width: 767px) {
		height: 240px;
	}
`

const CategoryTileTitle = styled.span`
	z-index: 5;
	position: absolute;
	display: block;
	color: #ffffff;
	font-family: Mallory;
	font-size: 18px;
	font-weight: 300;
	letter-spacing: 0;
	line-height: 22px;
	left: 24px;
	bottom: 52px;
	@media (max-width: 767px) {
		left: 12px;
		bottom: 38px;
	}
`

const ViewButton = styled.div`
	z-index: 5;
	left: 24px;
	bottom: 24px;
	position: absolute;
	display: block;
	@media (max-width: 767px) {
		left: 12px;
		bottom: 12px;
	}
`

const ViewButtonText = styled.span`
	color: #ffffff;
	font-family: Mallory;
	font-size: 13px;
	font-weight: 300;
	letter-spacing: 1px;
	line-height: 16px;
	text-decoration: none;
`

const CategoryImageOverlay = styled.div`
	z-index: 4;
	position: absolute;
	height: 333px;
	width: 260px;
	background: rgba(0, 0, 0, 0.4);
	@media (max-width: 767px) {
		width: 169px;
		height: 240px;
	}
`

export const BottomCategories = ({ data, topData }) => {
	const firstCat = topData.results[0]?.data.more_from_milligram?.slug
	const secondCat = topData.results[0]?.data.more_from_milligram_2?.slug
	const thirdCat = topData.results[0]?.data.more_from_milligram_3?.slug
	const fourthCat = topData.results[0]?.data.more_from_milligram_4?.slug
	const items = data.results

	const filterContext = useContext(FilterContext)
	const { filterArticles, setFilterCategory } = filterContext

	const handleClick = (e, selectedCategory) => {
		setFilterCategory(kebabCase(selectedCategory))
		if (selectedCategory) {
			filterArticles(selectedCategory, "category")
		}
	}

	const titleCase = (input) => {
		input = input
			.toLowerCase()
			.split(" ")
			.map(function (word) {
				return word.replace(word[0], word[0].toUpperCase())
			})

		return input.join(" ")
	}

	return (
		<>
			<Container>
				<SectionTitle>More from Milligram Notes</SectionTitle>
				<CategoryContainer>
					{items.map((category, i) => {
						if (
							category.uid == firstCat ||
							category.uid == secondCat ||
							category.uid == thirdCat ||
							category.uid == fourthCat
						) {
							return (
								<CategoryTile
									key={`${category.data.title[0]}-${i}}`}
									onClick={(e) => {
										handleClick(e, kebabCase(category.data.title[0].text))
										scrollToTop()
									}}
								>
									<Link
										style={{ textDecoration: "none" }}
										to={`/blogs/all/tagged/${category.slugs[0]}`}
									>
										<CategoryImageOverlay />
										<CategoryTileImage src={category.data.featured_image.url} />
										<CategoryTileTitle>
											{titleCase(category.data.title[0].text)}
										</CategoryTileTitle>
										<ViewButton>
											<ViewButtonText>VIEW</ViewButtonText>
											<ArrowRight style={{ marginLeft: "8px" }} size="15" color="white" />
										</ViewButton>
									</Link>
								</CategoryTile>
							)
						}
					})}
				</CategoryContainer>
			</Container>
		</>
	)
}

function scrollToTop() {
	window.scrollTo({ top: 0, behavior: "smooth" })
}
